import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'agl-one-col-program',
  templateUrl: './one-col-program.component.html',
  styleUrls: ['./one-col-program.component.scss']
})
export class OneColProgramComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
